const theme = {
  font: {
    family:
      "Roboto, --apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen,Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif,",
    body: {
      size: "14px",
      weight: "400",
      lineHeight: "20px",
    },
  },
  colors: {
    black: "rgba(0,0,0,1)",
    gstWhite: "rgba(255,255,255,1)",
    gstBlue: "#66d7d1",
    gstGrey: "rgb(231, 231, 231)",
    lightGrey: "rgb(153,153,153)",
    gstlightGrey: "#f0f0f0",
    gstdarkGrey: "#f3f0eb",
    hoverBlue: "#005580",
    gstRed: "red",
    whichHeader: "#F7F7F7",
    cocoheader: "#3AA09B",
    grey: "#616161",
  },
};

export { theme };
